import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import { ColumnDefResolved } from "@tanstack/react-table"
import { Command } from "cmdk"

import generateRandomKey from "@utils/generateRandomKey"

import { MobileHeader } from "@molecules/index"

import { BottomSheet } from "@organisms"
import useBottomSheet from "@organisms/BottomSheet/BottomSheet.store"
import useTable from "@organisms/Table/Table.context"

import styles from "./BottomSheetAddColumns.module.scss"
import { BottomSheetAddColumnsProps } from "./BottomSheetAddColumns.types"

export default function BottomSheetAddColumns<T>(props: BottomSheetAddColumnsProps) {
    const { isVisible } = props

    const { updateColumnVisibility, invisibleColumns } = useTable<T>()
    const { setContentActive } = useBottomSheet()

    const handleColumnVisibilityChange = (column: ColumnDefResolved<T>) => {
        updateColumnVisibility(column.accessorKey as string, true)
    }

    const noColumns = invisibleColumns.length === 0

    const onHeaderBackClick = () => setContentActive("columns")

    if (noColumns) {
        return (
            <>
                <MobileHeader
                    title="Add Column"
                    showBackButton={true}
                    onBackClick={onHeaderBackClick}
                    isTabbable={isVisible}
                    showDragIndicator={true}
                />
                <div className={styles.noColumns}>
                    <div className={styles.noColumnsText}>No columns to add</div>
                </div>
            </>
        )
    }

    if (isVisible) {
        return (
            <Command>
                <MobileHeader
                    title="Add Column"
                    onBackClick={onHeaderBackClick}
                    showDivider={false}
                    showBackButton={true}
                    isTabbable={isVisible}
                    showDragIndicator={true}
                />
                <div className={styles.searchInput}>
                    <BottomSheet.SearchInput />
                </div>
                <Command.List>
                    <Command.Empty>
                        <div className={styles.noColumns}>
                            <div className={styles.noColumnsText}>No columns found</div>
                        </div>
                    </Command.Empty>
                    <Command.Group className={styles.items}>
                        {invisibleColumns.map((column) => (
                            <Command.Item key={generateRandomKey()} value={column.header}>
                                <BottomSheet.Item
                                    icon={icon({
                                        name: "plus",
                                        style: "light",
                                        family: "sharp",
                                    })}
                                    isTabbable={isVisible}
                                    label={column.header as string}
                                    onClick={() => handleColumnVisibilityChange(column)}
                                />
                            </Command.Item>
                        ))}
                    </Command.Group>
                </Command.List>
            </Command>
        )
    } else {
        return null
    }
}
